import type { SxProps } from "@mui/material";
import { Drawer, Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { FOOTER_HEIGHT } from "./fixed-footer";

const SIDEBAR_WIDTH = 285;

export const FullScreenSidebar: FC<{
  open: boolean;
  children: ReactNode;
  fullHeight?: boolean;
  sx?: SxProps;
}> = ({ open, children, fullHeight = false, sx = [] }) => {
  const theme = useTheme();
  if (!open) return null;

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: SIDEBAR_WIDTH,
        height: `calc(100% - ${fullHeight ? 0 : FOOTER_HEIGHT})`, // Subtract the height of the footer
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          position: "relative",
          width: SIDEBAR_WIDTH,
          height: "100%",
          background: theme.palette.background.default,
        },
      }}
    >
      <Stack direction="column" spacing={0} sx={{ m: 2, ...sx }}>
        {children}
      </Stack>
    </Drawer>
  );
};
